module.exports = __webpack_public_path__ + "img/icon-search.6c4e2697.png";